import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { Link as ScrollLink, Element , Events, animateScroll, scrollSpy, scroller } from 'react-scroll';

import { useQuery } from '@apollo/react-hooks';
import { GET_RECRUITS } from './queries';
import { IRecruits } from '../../helper/Types';

import moment from 'moment';
import { VALoading, VALazyImage } from '../../components';
import { useQueryParams, StringParam } from 'use-query-params';

function RecruitsContainer() {
    const history = useHistory();
    const [more, setMore] = useState(true);
    const [limit, setLimit] = useState(20);

    const [query, setQuery] = useQueryParams({
        openIndex: StringParam,
        lastIndex: StringParam
    });

    const [openIndex, setOpenIndex] = useState<string[]>([]);
    const [lastIndex, setLastIndex] = useState<string>("");
    const [countMedia, setCountMedia] = useState(0);

    const loadData = useQuery<IRecruits>(GET_RECRUITS, {
        variables: {
            offsetDate: undefined,
            limit: limit
        },
        fetchPolicy: "cache-first"
    });

    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const loadedData:any = loadData.data?.recruits;
            setMore(loadedData.count > loadedData.posts.length);
            if( query.openIndex === undefined ) {
                setOpenIndex(["0"]);
            }
        }
    }, [loadData]);


    const handleOnLoad = () => {
        setCountMedia(countMedia + 1);
    }

    const handleScroll = () => {
        if( query.openIndex !== undefined ) {
            const total = query.openIndex.split('|').length;
            console.log("countMedia / total : " + countMedia + " / " + total);
            if( countMedia === total ) {
                const idx:number = parseInt(query.lastIndex as string, 10);
                if( idx >= 0 ) {
                    console.log("[done]scroll : " + idx );
                    const target = `uid-${query.lastIndex}`;
                    scroller.scrollTo(target, {
                        duration: 500,
                        delay: 0,
                        smooth: true,
                        containerId: 'recruit-scroll-container'
                    });
                }
            }
        }
    }

    useEffect(() => {
        handleScroll();
    }, [countMedia]);


    useEffect(() => {
        setQuery({
            openIndex: openIndex.join('|'),
            lastIndex: lastIndex
        });
    }, [openIndex, lastIndex]);


    useEffect(() => {
        console.log("history.location.pathname");
        console.log(history.location.pathname);
        setCountMedia(0);
        setOpenIndex(["0"]);
        setLastIndex("0");
    }, [history.location.pathname]);

    // mount
    useEffect(() => {
        let _openIndex:any = [];
        if( query.openIndex !== undefined ) {
            _openIndex = query.openIndex.split('|');
            console.log(_openIndex);
            setOpenIndex(_openIndex);
        }
        if( query.lastIndex !== undefined ) {
            setLastIndex(query.lastIndex);
        }
    }, []);




    const handleLoadMore = (offsetDate:String) => {
        const { data, fetchMore } = loadData;
        fetchMore({
            variables: {
                offsetDate: offsetDate,
                limit: limit
            },
            updateQuery: (prev:any, { fetchMoreResult } ) => {
                if (!fetchMoreResult) return prev;

                const posts = [...prev.recruits.posts, ...fetchMoreResult.recruits.posts];
                setMore(fetchMoreResult.recruits.count < posts.length)
                
                return Object.assign({} , prev, {
                    recruits: {
                        ...prev.recruits,
                        posts: posts,
                    }
                });
            }
        })
    }


    // const target = `uid-${query.lastIndex}`;
    // window.setTimeout(function() {
    //     scroller.scrollTo(target, {
    //         duration: 500,
    //         delay: 0,
    //         smooth: true,
    //         containerId: 'recruit-scroll-container'
    //     });
    // }, 1000);



    return(
        <article className="layout-contents-container stretch">
            <h1 className="hidden">채용 목록</h1>


            <table className="tbl-default-v2">
                <caption>채용 목록</caption>
                <thead>
                    <tr>
                        <th className="column-index">No</th>
                        <th className="column-date">Date</th>
                        <th className="column-full">Title</th>
                    </tr>
                </thead>
                <tbody id="recruit-scroll-container">
                    { loadData.loading && <tr><td colSpan={3} className="none"><VALoading /></td></tr> }
                    { loadData.error && <tr><td colSpan={3} className="none">에러가 발생했습니다.<br/>{loadData.error.message}</td></tr> }

                    { loadData.data?.recruits.posts.length === 0 && <tr><td colSpan={3} className="none">등록된 내용이 없습니다.</td></tr> }
                    { loadData.data?.recruits.posts.map((_post:any, _index:number) => {
                        const total:any = loadData.data?.recruits.posts.length;

                        const handleOpen = (_index:string) => {
                            let _openIndex = [...openIndex];
                            if( !_openIndex.includes(_index) ) {
                                _openIndex.push(_index);
                            }
                            setOpenIndex(_openIndex);
                            setLastIndex(_index);
                            // console.warn("handleClick[" + _index + "] : ", _openIndex);
                        }

                        const handleClose = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string) => {
                            let _openIndex = [...openIndex];
                            if( _openIndex.includes(_index) ) {
                                const idx = _openIndex.indexOf(_index);
                                if( idx > -1 ) {
                                    _openIndex.splice(idx, 1);
                                    setOpenIndex(_openIndex);
                                    setLastIndex(_index);
                                    setCountMedia(countMedia - 1);
                                    // console.warn("handleClose[" + _index + "] : ", _openIndex);
                                }
                            }
                            setLastIndex(_index);
                        }


                        return(
                            <Element key={_index} name={`uid-${_index}`}>
                            {/* <HashLink key={_index} to={`/recruit#${_post.uid}`} smooth */}
                                <tr data-expand={openIndex.includes(_index.toString())} onClick={() => {
                                    if( !openIndex.includes(_index.toString()) ) {
                                        handleOpen(_index.toString());
                                    }
                                }}>
                                    <td className="column-index">{total - _index}</td>
                                    <td className="column-date">{moment(Number(_post.date)).format("YYYY.MM.DD")}</td>
                                    <th className="column-full">
                                        <span className="title" onClick={(e) => {
                                            if( openIndex.includes(_index.toString()) ) {
                                                handleClose(e, _index.toString());
                                            }
                                        }}>
                                            {_post.title}
                                        </span>
                                        
                                        { openIndex.includes(_index.toString()) &&
                                            <div className="expand-contents">
                                                <div className="media">
                                                    <img src={_post.cover[0].url} alt={_post.title} onLoad={handleOnLoad} />
                                                </div>
                                                <p>
                                                    {_post.description.split('\n').map( (_item:any) => {
                                                        return(<>{_item}<br/></>)
                                                    })}
                                                    <a href={`mailto:${_post.recruit.recipient}`} target="__blank" className="btn-email">{_post.recruit.recipient}</a>
                                                </p>
                                            </div>
                                        }
                                    </th>
                                </tr>
                            </Element>
                            // </HashLink>
                        )
                    }) }
                </tbody>
            </table>

            <div className="list-actions" data-disabled={!more}>
                <button type="button" className="button-read-more" disabled={!more} onClick={() => {
                    const items:any = loadData.data?.recruits.posts;
                    const _date:String = items && items[items.length-1].date;
                    handleLoadMore(_date);
                }}>Read More</button>
            </div>

        </article>
    );
}

export default RecruitsContainer;

